import { Link } from "react-router-dom";
import { useSeo, SITE_ORIGIN, SITE_NAME } from "@/hooks/useSeo";
import { siteMeta } from "@/mocks/siteMeta";
import { faqs } from "@/mocks/faqs";
import Hero from "./components/Hero";
import ChannelStrip from "./components/ChannelStrip";
import FeaturedZones from "./components/FeaturedZones";
import LatestFeed from "./components/LatestFeed";
import RankingBoard from "./components/RankingBoard";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  useSeo({
    title: "爆料91 - 爆料91专区已开启 栏目合集板块全收录",
    description:
      "爆料91专区聚合门户，把栏目、频道、板块内容统一归拢成合集。进入爆料91专区，一个入口看齐爆料91全部内容，想看什么直接点，找内容不再来回翻。",
    keywords: "爆料91,爆料91专区,爆料91栏目,爆料91频道,爆料91板块,爆料91内容合集",
    path: "/",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteMeta.name,
        url: `${SITE_ORIGIN}/`,
        email: siteMeta.email,
        description: siteMeta.description,
        foundingDate: siteMeta.foundedYear,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        alternateName: "爆料91专区",
        url: `${SITE_ORIGIN}/`,
        inLanguage: "zh-CN",
        description: siteMeta.tagline,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 4).map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <ChannelStrip />
      <FeaturedZones />
      <LatestFeed />
      <RankingBoard />
      <FaqPreview />

      <section className="w-full bg-accent-50 border-t border-accent-200">
        <div className="w-full px-4 md:px-8 py-12 md:py-16">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 rounded-lg border border-accent-200 bg-background-50 p-6 md:p-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-accent-800">
                <span className="w-5 h-px bg-accent-600"></span>
                Get Started
              </span>
              <h2 className="mt-3 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                想看什么，直接从专区点进去
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                不用先想关键词，也不用一页页往下翻。按专区浏览，合集已经替你排好顺序，
                打开就是一整块内容。
              </p>
            </div>
            <Link
              to="/zones"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
            >
              <i className="ri-compasses-2-fill"></i>
              进入爆料91专区
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}